import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'
import { Font, config } from '../../../constants'

export interface LvcSimpleModal {
  modalId: string
  modalStatus: string
  modalTitle: string
  titleSize: string
  noCloseButton?: boolean
  maxWidth?: string
  theme?: string
}

export class LvcSimpleModal extends MinzeElement {
  attrs: Attrs = [
    'modal-id',
    'modal-title',
    'no-close-button',
    'close',
    'max-width',
    ['theme', 'default'],
    'clip-path',
    'background',
    ['title-size', '60px'],
    ['text-transform', 'none'],
    ['simple-close-button', 'false'],
  ]
  static observedAttributes = ['close']
  _authHandler: any = null

  onCloseButtonClick() {
    this.closeModal()
  }

  onOverlayClick() {
    this.closeModal()
  }

  closeModal() {
    this.cast('close')
    this.remove()
  }

  onAttributeChange(name: string, oldValue: string, newValue: string) {
    if (name === 'close' && newValue === 'true') {
      this.closeModal()
    }
  }

  html = () => `
   
    <div id="lvc-modal-overlay" class="lvc-modal-overlay">
    </div>
    <div class="lvc-modal-wrapper">
      <div id="lvc-modal" class="lvc-modal">
        ${
          !this.modalTitle && this.noCloseButton
            ? ''
            : `
          <div class="header">
            ${(this.modalTitle && `<div class="title">${this.modalTitle}</div>`) || ''}
            ${this.noCloseButton ? '' : `<div id="lvc-close-button">${this.simpleCloseButton ? `<lvc-close-icon width="16.8px" height="16.8px"></lvc-close-icon>` : `<lvc-circle-close-icon></lvc-circle-close-icon>`}</div>`}
          </div>
        `
        }
        <slot></slot>
      </div>
    </div>
  `

  css = () => {
    let theme = ''

    if (this.theme === 'neat') {
      theme = `
        .lvc-modal, .lvc-modal-wrapper {
         --webkit-clip-path: none;
         clip-path: none;
        }

        .lvc-modal {
          padding: 16px;
          border-radius: 12px;
        }

        .title {
          text-transform: uppercase;
          font-size: 20px;
        }
      `
    }

    return `
      :host {
        z-index: 100000;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: block;
      }
      
      #lvc-close-button {
        cursor: pointer;
      }

      .lvc-modal {
        ${this.background ? `background: ${this.background};` : `background: linear-gradient(to top left, #ffff, rgba(255, 153, 150, 0), #899AFE), linear-gradient(to top right, #ffff,rgba(255, 153, 150, 0), #00C2B6) #ffff;`}
        padding: 24px;
        border-radius: 12px;
        max-height: 100vh;
        overflow-y: auto;
        ${this.maxWidth ? `max-width: ${this.maxWidth}` : ``};
        ${
          this.clipPath
            ? `
        -webkit-mask-image: url(${config.images.popupMask});
        mask-image: url(${config.images.popupMask});
        -webkit-mask-size: contain;
        mask-size: contain;
        mask-repeat: no-repeat;
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-position: center;
        mask-position: center;
      `
            : ''
        } 
        font-smooth: always;
      }
      
      .lvc-modal-wrapper {

        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 2px;
        border-radius: 12px;
        font-smooth: always;
      }
      
      @media screen and (max-width: 730px) {
        .lvc-modal-wrapper {
          width: 90%;
        }
      }

      .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0px;
        min-width: 448px;
        width: 100%;
        height: 40px;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
      }
      
      @media (max-width: 767px) {
        .lvc-modal {
          max-width: 100%;
        }
        .header {
          min-width: 0px;
        }
      }
     

      .title {
        font-family: ${Font.family};
        font-style: normal;
        font-weight: ${Font.weight.extraBold};
        font-size: ${this.titleSize};
        text-transform: ${this.textTransform};
        line-height: 100%;
        font-feature-settings: 'tnum' on, 'lnum' on;
        color: #1E007D;
        order: 0;
        flex-grow: 0;
      }

      .lvc-modal-overlay {
        position: fixed; /* Stay in place */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgba(0,0,0,0.25);
        cursor: pointer;
      }


      ${theme}
    `
  }

  eventListeners: EventListeners = [
    ['#lvc-modal-overlay', 'click', this.onOverlayClick.bind(this)],
    ['#lvc-close-button', 'click', this.onCloseButtonClick.bind(this)],
  ]
}
